export const RecordOnMeetingFragment = gql`
  fragment RecordOnMeetingFragment on RecordOnMeeting {
    id
    canBeRemoved
    cannotBeRemovedReason
    meetingComments
    files {
      ...FileFragment
    }
    meeting {
      id
      uuid
      startTime
      location
      cancelledAt
      meetingBoard {
        id
        name
      }
    }
    meetingResult {
      id
      name
    }
  }
`
